import { useEffect, useState, useCallback } from 'react';
import type { CardType } from '../../../../../model/types.tsx';

type Props = {
	defaultCardTypeId: string | null;
	initialCardTypes: Array<CardType>;
};
export const useSelectedIssueType = ({ defaultCardTypeId, initialCardTypes }: Props) => {
	const [selectedIssueTypeId, setSelectedIssueTypeId] = useState<number | undefined>(
		Number(defaultCardTypeId) || initialCardTypes[0]?.id,
	);

	// When defaultCardTypeId not set: default to first card type
	useEffect(() => {
		if (!defaultCardTypeId && initialCardTypes.length) {
			setSelectedIssueTypeId(initialCardTypes[0].id);
		}
	}, [defaultCardTypeId, initialCardTypes]);

	const onChangeIssueType = useCallback((cardTypeId: string | number) => {
		setSelectedIssueTypeId(Number(cardTypeId));
	}, []);

	return {
		selectedIssueType:
			initialCardTypes.find(({ id }) => id === selectedIssueTypeId) || initialCardTypes[0],
		onChangeIssueType,
	};
};
